var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kbd',{staticClass:"hotkey p-0.5 min-w-[1rem] uppercase",class:_vm.customClass},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }